<script setup>
import { computed } from 'vue'
const props = defineProps({ type: String })
const config = computed(() => {
  switch (props.type) {
    case 'GREY': return { src: 'raumpionere-logo-grey.png', alt: 'Raumpioniere Logo Grey' }
    case 'BLACK': return { src: 'raumpioniere-black-logo.png', alt: 'Raumpioniere Logo Black' }
  }
  return 'missingImg.png'
})
</script>

<template lang="pug">
img.raumpioniereLogo(
  :src="`https://raumpionierestorage.blob.core.windows.net/images/${config.src}`"
  :alt="config.alt"
)
</template>

<style scoped lang="sass">
.raumpioniereLogo
  width: 48px
  height: 14px
  position: absolute
  @media screen and (min-width: 600px)
    bottom: 20px
    right: 20px
  @media screen and (max-width: 599px)
    bottom: 15px
    right: 15px
</style>
